<template>
    <div>
        <el-row>
            <el-col :span="24" class="top-title">
                <div>
                    课后练习
                </div>
                <div class="change-class-box">
                    <el-select v-model="form.where.class_guid" placeholder="请选择" @change="changeClass">
                        <el-option
                        v-for="item in classList"
                        :key="item.class_guid"
                        :label="item.class_name"
                        :value="item.class_guid">
                        </el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="18" :offset="3" class="examination-box">
                <el-tabs type="border-card" style="min-height:80vh" @tab-click="clickTabChangeFlag">
                    

                <el-tab-pane label="未完成">
                    <div>
                        <el-form ref="form" :model="form" label-width="80px">
                            <el-row>
                                <el-col :span="6">
                                    <el-form-item label="时间：">
                                        <el-select v-model="form.where.time_type" placeholder="请选择时间" @change="changeFormData">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,index) in timeTypeData" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6">
                                    <el-form-item label="标签：">
                                        <el-select v-model="form.where.tag_guid" placeholder="请选择标签" @change="changeFormData">
                                        <el-option :label="item.detail_name" :value="item.detail_guid" v-for="(item,index) in tagData" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6">
                                    <el-form-item label="排序：">
                                        <el-select v-model="form.where.sort_type" placeholder="请选择排序" @change="changeFormData">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,index) in sortData" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <el-row>
                        <div v-if="list.length !== 0">
                            <el-col :span="12" v-for="(item,index) in list" :key="index" >
                                <div class="work-box">
                                    <el-card class="box-card">
                                        <div class="work-title">
                                            {{item.work_name}}
                                        </div>
                                        <el-row>
                                            <el-col :span="6">
                                                <div class="work-img-div">
                                                    <img :src="logoList[item.work_category_id]" style="width:70%" alt="">
                                                </div>
                                            </el-col>
                                            <el-col :span="16" class="work-desc">
                                                <div class="work-start-time">
                                                    开始时间：{{item.start_time}}
                                                </div>
                                                <div class="work-end-time">
                                                    结束时间：{{item.end_time}}
                                                </div>
                                                <div class="work-teacher-name">
                                                    {{item.teacher_name}}
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                        
                                            <template>
                                                    <el-popover
                                                        placement="top-start"
                                                        title=""
                                                        width=""
                                                        trigger="hover"
                                                        content="开始答题。">
                                                        <div class="work-show-btn" @click="startWork(item)" slot="reference">
                                                            <i class="el-icon-edit-outline"></i>
                                                        </div>
                                                    </el-popover>
                                                </template>
                                        
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </div>
                            </el-col>
                        </div>
                        <div v-else>
                            <el-empty description="暂无数据" :image-size="300"></el-empty>
                        </div>

                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="已完成">
                    <div>
                        <el-form ref="form" :model="form" label-width="80px">
                            <el-row>
                                <el-col :span="6">
                                    <el-form-item label="时间：">
                                        <el-select v-model="form.where.time_type" placeholder="请选择时间" @change="changeFormData">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,index) in timeTypeData" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6">
                                    <el-form-item label="标签：">
                                        <el-select v-model="form.where.tag_guid" placeholder="请选择标签" @change="changeFormData">
                                        <el-option :label="item.detail_name" :value="item.detail_guid" v-for="(item,index) in tagData" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6">
                                    <el-form-item label="排序：">
                                        <el-select v-model="form.where.sort_type" placeholder="请选择排序" @change="changeFormData">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,index) in sortData" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <el-row>
                        <div v-if="list.length !== 0">
                            <el-col :span="12" v-for="(item,index) in list" :key="index" >
                                <div class="work-box">
                                <el-card class="box-card">
                                    <div class="work-title">
                                        {{item.work_name}}
                                    </div>
                                    <el-row>
                                        <el-col :span="6">
                                            <div class="work-img-div">
                                                <img :src="logoList[item.work_category_id]" style="width:70%" alt="">
                                            </div>
                                        </el-col>
                                        <el-col :span="16" class="work-desc">
                                            <div class="work-start-time">
                                                开始时间：{{item.start_time}}
                                            </div>
                                            <div class="work-end-time">
                                                结束时间：{{item.end_time}}
                                            </div>
                                            <div class="work-teacher-name">
                                                {{item.teacher_name}}
                                            </div>
                                        </el-col>
                                        <el-col :span="2">
                                            <template>
                                                <el-popover
                                                    placement="top-start"
                                                    title=""
                                                    width=""
                                                    trigger="hover"
                                                    content="查看报告。">
                                                    <div class="work-show-btn" @click="showReport(item)" slot="reference">
                                                        <i class="el-icon-s-opportunity"></i>
                                                    </div>
                                                </el-popover>
                                            </template>
                                      
                                        </el-col>
                                    </el-row>
                                </el-card>
                                </div>
                            </el-col>
                        </div>
                        <div v-else>
                            <el-empty description="暂无数据" :image-size="300"></el-empty>
                        </div>
          
                    </el-row>
      
                </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
        <Waterfall ref="Waterfall" :dataList = "dataList" :list="list" :form="form"></Waterfall>
    </div>
   
</template>

<script>
    import { classTestStuList, getStuHomeworkTags, classMemberList} from '@/api'
    import store from '@/store'
    import Waterfall from '@/components/waterfall'

    export default {
        name: 'Examination',
        components: {
            Waterfall
        },
        props: ['cate', 'words'],
        data() {
            return {
                classPopver:false,
                dialogVisible: false,
                list:[],
                classList:[],
                listForm:{
                        'page':1,
                        'limit':99,
                        'where':{}
                },
                form:{
                    page: 1,
                    limit: 10,
                    where: {
                        work_category_id: '',
                        complete_flag: 'N',
                        time_type:'',
                        class_guid: '',
                        list_type:1,
                        tag_guid:'',
                        sort_type:1
                    }
                },
                timeTypeData:[
                    {
                        label:'全部',
                        value:''
                    },
                    {
                        label:'一周',
                        value:7
                    },
                    {
                        label:'一个月',
                        value:30
                    },
                    {
                        label:'三个月',
                        value:90
                    },
                    {
                        label:'半年',
                        value:180
                    },
                    {
                        label:'一年',
                        value:365
                    },
                ],
                workCategoryData:[
                    {
                        label:'全部类型',
                        value:''
                    },
                    {
                        label:'答题卡作业',
                        value:1
                    },
                    {
                        label:'题库作业',
                        value:2
                    },
                    {
                        label:'分层作业',
                        value:3
                    },
                    {
                        label:'单词作业',
                        value:5
                    },
                ],
                tagData:[
                    {
                        detail_name:'全部',
                        detail_guid:''
                    },
                ],
                sortData:[
                    {
                        label:'倒序',
                        value:1
                    },
                    {
                        label:'正序',
                        value:2
                    },
                ],
                defaultLogo:"http://foo.ibianma.com/jingying/word/2022/12/01/d865fb6a3bb7ec265c0942e89337797b.png",
                logoList:{
                    1:"http://foo.ibianma.com/jingying/word/2022/12/01/90473139a17ff1b3657c556f00fc8c9c.png",//答题卡
                    2:"http://foo.ibianma.com/jingying/word/2022/12/01/d865fb6a3bb7ec265c0942e89337797b.png",//题库作业
                    3:"http://foo.ibianma.com/jingying/word/2022/12/01/a44f88abe3be60022b8e9f48d71e11a9.png",//分层
                    4:"http://foo.ibianma.com/jingying/word/2022/12/01/8a237ccb83ddecdf423a56c89777a667.png",//分层
                    5:"http://foo.ibianma.com/jingying/word/2022/12/01/4c8756eb5980d6d7f8e3f7d1b2d5ee47.png",//单词

                }
            }
        },
        computed: {
        },
        methods: {

            dataList(clearFlag)
            {
                if(clearFlag === true)
                {
                    this.list = []
                    this.form.page = 1
                }
                classTestStuList(this.form).then(response => {
                    if(response.data.length != 0)
                    {
                        this.list = this.list.concat(response.data)
                        this.$refs.Waterfall.isLoading = false
                    }
               
                })
      
            },
            changeClass()
            {

                var class_guid = this.form.where.class_guid
                var userInfo = this.$store.state.user.userInfo
                userInfo.class_guid = class_guid
                
                store.dispatch('user/setUserInfoData', userInfo);
                this.dataList(true)
            },
            classMemberList()
            {
                classMemberList(this.listForm).then(response => {
                    this.classList = response.data
                })
      
            },
            clickTabChangeFlag()
            {
                if(this.form.where.complete_flag == 'Y')
                {
                    this.form.where.complete_flag = 'N'
                }
                else
                {
                    this.form.where.complete_flag = 'Y'
                }
                this.dataList(true)
            },
            changeFormData(){
                this.dataList(true)
            },
            showReport(e)
            {

                if(e.report_list_flag == 'Y')
                {
                    this.$router.push({path:'/viewreport',query: {work_guid:e.work_guid}})
                }
                else
                {
                    this.$notify.success({
                        title: '信息提示',
                        message: e.report_unavailable_msg,
                        duration: 3000
                    })
                }
            },
            startWork(e)
            {
                this.$router.push({path:'/homeworkanswer',query: {work_guid:e.work_guid}})

            },
            getStuHomeworkTags()
            {
                var form = {class_guid: this.form.where.class_guid }
                getStuHomeworkTags(form).then(response => {
                    if(response.length != 0)
                    {
                        this.tagData = response
                    }
                })
            }

        },
        mounted() {

            this.form.where.class_guid = this.$route.query.class_guid
            this.dataList()
            this.getStuHomeworkTags()
            this.classMemberList()
        }
    }
</script>
<style scoped lang="less">

    .change-class-box{
        text-align: right;
        padding-right: 14%;
    }
    .top-title{
        text-align: center;
        font-size:24px;
        margin-top:1vh;
    }

    .examination-box{
        margin-top:5vh;
    }

    .work-box{
        padding:30px;
    }


    .work-title{
        font-size:24px;
        padding-bottom:10px;
    }

    .work-start-time{
        margin-top:10px;
    }

    .work-end-time{
        margin-top:10px;
    }

    .work-teacher-name{
        margin-top:10px;
    }

    .work-img-div{
        padding:10px;
    }

    .work-show-btn{
        font-size: 28px;
        color: #409EFF;
        cursor: pointer;
        margin-top: 65px;
    }

    .work-desc{
        font-size:18px;
    }

    @media (max-width: 1400px) {
        .work-desc{
            font-size:14px;
        }
    }

</style>
